import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props)  {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg width="100%" height="100%" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1.33333,0,0,1.33333,-1.04895e-13,-0.0005)">
        <path d="M9.939,7.856C9.442,7.559 8.805,7.918 8.805,8.5L8.805,15.5C8.805,16.085 9.443,16.439 9.939,16.145L15.808,12.65C16.296,12.359 16.295,11.653 15.809,11.361L9.939,7.856ZM10.305,14.181L10.305,9.821L13.96,12.004L10.305,14.181Z" style="fill-rule:nonzero;"/>
    </g>
    <g transform="matrix(1.33333,0,0,1.33333,-1.04895e-13,-0.0005)">
        <path d="M19.904,3.271C15.251,2.58 8.751,2.58 4.096,3.271C2.234,3.547 0.767,5.009 0.447,6.907C-0.149,10.43 -0.149,13.571 0.447,17.093C0.767,18.992 2.234,20.453 4.096,20.729C6.428,21.075 9.22,21.248 12.011,21.248C14.797,21.248 17.582,21.076 19.905,20.73C21.765,20.454 23.231,18.993 23.553,17.094C24.149,13.571 24.149,10.429 23.553,6.906C23.233,5.009 21.766,3.547 19.904,3.271ZM22.074,16.844C21.861,18.1 20.901,19.066 19.684,19.246C15.166,19.917 8.846,19.917 4.316,19.245C3.098,19.064 2.137,18.099 1.925,16.843C1.351,13.449 1.351,10.552 1.925,7.156C2.138,5.9 3.098,4.936 4.317,4.754C6.579,4.419 9.29,4.251 11.999,4.251C14.71,4.251 17.421,4.419 19.683,4.754C20.901,4.935 21.862,5.9 22.074,7.156C22.648,10.552 22.648,13.449 22.074,16.844Z" style="fill-rule:nonzero;"/>
    </g>
</svg>
`,
      }}
    />
  );
};
